import { useMemo } from "react";
import { getUrlQueries } from "utilities/routes";

/** Memoized getUrlQueries */
export function useQueryParams(url: string) {
  return useMemo(() => {
    return getUrlQueries(url);
  }, [url]);
}
